import { WATCHER_SLUG__page_generation } from '../_base/watchers/set_workspace_current/WATCHER_SLUG__page_generation';
import { WATCHER__user_task_load_generations } from '../_base/watchers/WATCHER__user_task_load_generations';
import { WATCHER__disable_generation_ui } from './_watchers/generation/WATCHER__disable_generation_ui';
import { WATCHER__generation_consume_content_reset } from './_watchers/generation/WATCHER__generation_consume_content_reset';
import { WATCHER__generation_error } from './_watchers/generation/WATCHER__generation_error';
import { WATCHER__generation_next } from './_watchers/generation/WATCHER__generation_next';
import { WATCHER__generation_reset_token_list_add_lora_tag } from './_watchers/WATCHER__generation_reset_token_list_add_lora_tag';
import { WATCHER__generation_tool_output_type } from './_watchers/WATCHER__generation_tool_output_type';
import { WATCHER__image_asset_prevew_reset } from './_watchers/WATCHER__image_asset_prevew_reset';
import { WATCHER__image_edit_reset_field } from './_watchers/WATCHER__image_edit_reset_field';
import { WATCHER__unet_inpaint } from './_watchers/WATCHER__unet_inpaint';
import { WATCHER_SLUG__remove_grid2d_offset } from './_watchers/WATCHER_SLUG__remove_grid2d_offset';
import { G_PAGE_LAYOUT_DESKTOP__generation } from './G_PAGE_LAYOUT_DESKTOP__generation';
import { WATCHER__generation_token_edit_reset } from './sidebar/token/WATCHER__generation_token_edit_reset';

export function G_PAGE__generation() {
  /*
   * METHODS
   */

  return (
    <>
      <WATCHER__unet_inpaint />

      <WATCHER__image_asset_prevew_reset />

      <WATCHER__generation_tool_output_type />

      <WATCHER_SLUG__page_generation />

      <WATCHER_SLUG__remove_grid2d_offset />

      <WATCHER__user_task_load_generations />

      <WATCHER__disable_generation_ui />

      <WATCHER__generation_next />

      <WATCHER__generation_consume_content_reset />

      <WATCHER__generation_error />

      <WATCHER__image_edit_reset_field />

      <WATCHER__generation_reset_token_list_add_lora_tag />

      <WATCHER__generation_token_edit_reset />

      <G_PAGE_LAYOUT_DESKTOP__generation />
    </>
  );
}
